import React, {useEffect, useState} from 'react';
import './Format.scss';
import FormatItem from "./FormatItem";
import {t} from 'react-switch-lang';
import Label from 'reactstrap/lib/Label';

const FormatList = ({value, parameterName, onChange, error, isSubmitted, setIsSubmitted, setSelectedFormat, isValidType}) => {
    const [values, setValues] = useState([]);
    const [selectedType, setSelectedType] = useState('');

    const handleClick = (e) => {
        const api = `${parameterName}=${e}`;
        setSelectedType(e);
        setSelectedFormat(e);
        onChange(api);
        setIsSubmitted();
    };

    const handleFormatTypes = (types) => {
        return  types.map((item, index) => {
            return <FormatItem
                key={index}
                active={(selectedType === item)}
                type={item}
                onClick={() => handleClick(item)}
                />
        });
    };

    useEffect(() => {
        setValues(value);
    }, [value]);

    useEffect(() => {
        setSelectedType('');
    }, [isValidType]);

    return (
        <div>
            <label className="label">{t('reports.format')}</label>
            <div className="reports-format">
                {handleFormatTypes(values)}
            </div>
            {(isSubmitted && error && <span
                className="error-message position-absolute">{t('message.fieldRequired')}</span>)}
        </div>
    )
};

export default FormatList;